import { useQuery } from 'react-query';

import TodoService from '../../../services/TodoService';
import { TODO } from '../../constants/queryDefinition';

const todoService = TodoService.get();

const useTodoList = () => {
  return useQuery(TODO.TODOLIST, todoService.getTodos, {
    staleTime: TODO.STALE_TIME,
    cacheTime: TODO.STALE_TIME,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  });
};

export default useTodoList;
